var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / action / download-upload / download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9885 15V19C20.9885 19.5304 20.778 20.0391 20.4031 20.4142C20.0283 20.7893 19.5199 21 18.9898 21H4.99873C4.46863 21 3.96025 20.7893 3.58541 20.4142C3.21058 20.0391 3 19.5304 3 19V15",
    stroke: "#4F2D7F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.99609 10L11.9929 15L16.9897 10",
    stroke: "#4F2D7F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9922 15V3",
    stroke: "#4F2D7F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.332eb1139031d0822f6f1f98317f0104.svg";
export { ForwardRef as ReactComponent };